<div class="card bg-white cursor-pointer relative m-1 z-50"
     [ngClass]="{
     'bg-primaryWashed': notification.read_at === null && !loudNotification,
     'bg-yellowWashed80': notificationType === 'information',
     'bg-redWashed': notificationType === 'alert'
     }">
  <div class="card-body flex p-4">
    <div *ngIf="showCloseMark" class="p-1 absolute text-grayDark hover:text-red" style="top:6px; right:10px;"
         (click)="removeNotification()"
         i18n-title title="Odstrani obvestilo">
      <i class="fas fa-times"></i>
    </div>
    <div class="flex-auto cursor-pointer">
      <p class="notification-title font-bold">{{notification.data.notification_title}}</p>
      <div class="notification-body text-grayDark text-sm"
           [ngClass]="{'cursor-pointer': shouldShowExpandToggle()}"
           (click)="shouldShowExpandToggle() ? toggleExpanded($event) : null"
           [style.max-height]="isExpanded ? 'auto' : 'none'"
           [innerHTML]="getDisplayContent() | safeHtml">
      </div>
      <p *ngIf="shouldShowExpandToggle()" class="text-xs text-blue cursor-pointer hover:underline mt-1"
         (click)="toggleExpanded($event)">
        {{ isExpanded ? 'Prikaži manj' : 'Prikaži več' }}
      </p>
      <p class="text-sm text-gray">{{ createdAt }}</p>
      <p class="my-3" *ngIf="notification.data?.button_link?.length > 0">
        <button class="btn btn-sm btn-primary-outline text-sm"
                [attr.data-link]="notification.data.button_link"
                (click)="redirectToNotification(notification)">
          {{ notification.data.button_text }}
        </button>
      </p>
    </div>
  </div>
</div>
